import {
  Component,
  Input,
  Output,
  EventEmitter,
  OnChanges,
  SimpleChanges,
  ChangeDetectionStrategy,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormControl, ReactiveFormsModule, Validators } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { DeliveryRound } from '@models/delivery-round.model';
import { ItemDeliveryRoundHouseholdComponent } from '../item/item-delivery-round-household.component';

@Component({
  selector: 'app-delivery-round-mobile-item',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    TranslateModule,
    ItemDeliveryRoundHouseholdComponent,
  ],
  changeDetection: ChangeDetectionStrategy.Eager,
  templateUrl: './delivery-round-mobile-item.component.html',
})
export class DeliveryRoundMobileItemComponent implements OnChanges {
  @Input() round: DeliveryRound | null = null;
  @Input() expanded = false;

  @Output() selectRound = new EventEmitter<DeliveryRound>();
  @Output() deleteRound = new EventEmitter<DeliveryRound>();
  @Output() householdAction = new EventEmitter<any>();
  @Output() onRenameRound = new EventEmitter<{ id: number; name: string }>();

  nameControl = new FormControl('', [
    Validators.required,
    Validators.maxLength(100),
  ]);
  editingName = false;

  ngOnChanges(changes: SimpleChanges) {
    if (changes['round'] && this.round) {
      this.nameControl.setValue(this.round.name || '');
    }
  }

  toggle() {
    this.expanded = !this.expanded;
  }

  onSelect() {
    if (this.round) {
      this.selectRound.emit(this.round);
    }
  }

  requestDelete() {
    if (this.round) {
      this.deleteRound.emit(this.round);
    }
  }

  startRename(event?: Event) {
    if (event) event.stopPropagation();

    this.editingName = !this.editingName;

    if (!this.editingName && this.round) {
      this.nameControl.setValue(this.round.name || '');
    }
  }

  confirmRename() {
    if (this.round && this.nameControl.valid) {
      this.editingName = false;
      this.onRenameRound.emit({
        id: this.round.id,
        name: this.nameControl.value!,
      });
    }
  }

  cancelRename(event?: Event) {
    event?.stopPropagation();
    if (this.round) {
      this.nameControl.setValue(this.round.name || '');
    }

    this.editingName = false;
  }

  onHouseholdAction(event: any) {
    // bubble household actions to parent with round context
    this.householdAction.emit({ ...event, round: this.round });
  }
}
